import Button from '../base/Button';

export default function CTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-500 via-cyan-600 to-teal-700 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/20 to-transparent"></div>
      </div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          Bereit für deinen Mindshift?
        </h2>
        
        <p className="text-xl text-teal-50 mb-8 max-w-2xl mx-auto">
          Starte noch heute deine Reise zu mehr Klarheit und mentaler Stärke.
          <br />
          <strong className="text-white">Vertraulich, DSGVO-konform und in Deutschland gehostet.</strong>
        </p>
        
        <div className="flex justify-center">
          <Button 
            variant="secondary" 
            size="lg"
            onClick={() => window.open('https://t.me/mindshift_ai_bot', '_blank')}
            className="bg-white text-teal-600 hover:bg-gray-100 text-xl px-12 py-5 rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
          >
            <i className="ri-telegram-fill mr-4 text-2xl"></i>
            Jetzt 7 Tage kostenlos testen
          </Button>
        </div>
        
        <div className="mt-8 text-teal-50 text-lg flex items-center justify-center gap-6">
          <span className="flex items-center">
            <i className="ri-gift-line mr-2"></i>
            7 Tage kostenlos
          </span>
          <span className="flex items-center">
            <i className="ri-close-circle-line mr-2"></i>
            Keine Kreditkarte nötig
          </span>
          <span className="flex items-center">
            <i className="ri-shield-check-line mr-2"></i>
            DSGVO-konform
          </span>
        </div>
      </div>
    </section>
  );
}
